import { render, staticRenderFns } from "./GuidedQuizScreen.vue?vue&type=template&id=3e4df1fb&scoped=true&"
import script from "./GuidedQuizScreen.vue?vue&type=script&lang=js&"
export * from "./GuidedQuizScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4df1fb",
  null
  
)

export default component.exports